import React from "react";
import { UserState } from "redux-oidc";
import { ImageGallery } from "../Common/ImageGallery";
import { BugReport } from "../..";
import { TextDisplay, DateDisplay } from "../../../Common";
import FeedbackFileDisplay from "../Common/FeedbackFileDisplay/FeedbackFileDisplay";
import { userService } from "../../../User";
import { commentLinkSplitService } from "../../Services/CommentLinkSplitService";

type Props = {
  feedback: BugReport;
  user: UserState;
};

export const BugReportDetails: React.FC<Props> = props => {
  const isCMUser = userService.isUserCadmakers(props.user);

  let { link } = props.feedback;
  // sometimes users will add a link like "google.ca" instead of "http://google.ca"
  // we need to add the double slash in this case to let the browser know this is an external url
  if (!link.startsWith("http")) {
    link = `//${link}`;
  }

  return (
    <div>
      {isCMUser && (
        <div>
          <div style={{ display: "inline-block", marginRight: "10%" }}>
            <h4>Start Date</h4>
            {props.feedback.startDate ? (
              <DateDisplay date={new Date(props.feedback.startDate)} />
            ) : (
              <TextDisplay>N/A</TextDisplay>
            )}
          </div>
          <div style={{ display: "inline-block", marginRight: "10%" }}>
            <h4>Estimated Hours</h4>
            <TextDisplay>
              {props.feedback.estimatedHours ? props.feedback.estimatedHours : "N/A"}
            </TextDisplay>
          </div>
          <div style={{ display: "inline-block" }}>
            <h4>Browser</h4>
            <TextDisplay>
              {props.feedback.browserName ? props.feedback.browserName : "N/A"}
              {props.feedback.browserVersion ? ` : ${props.feedback.browserVersion}` : " "}
            </TextDisplay>
          </div>
        </div>
      )}
      <div>
        <h4>Reproduction Steps</h4>
        <TextDisplay>{props.feedback.reproductionSteps}</TextDisplay>
      </div>
      <div>
        <h4>Description</h4>
        <TextDisplay>
          {commentLinkSplitService.getLinkDisplay(props.feedback.description ?? "")}
        </TextDisplay>
      </div>
      <div>
        <h4>Expected Behaviour</h4>
        <TextDisplay>{props.feedback.expectedBehaviour}</TextDisplay>
      </div>
      <div>
        <h4>Link</h4>
        <p>
          <a target="_blank" href={link} rel="noopener noreferrer">
            {props.feedback.link}
          </a>
        </p>
      </div>
      {props.feedback.files.length > 0 && (
        <div>
          <h4>Files</h4>
          <FeedbackFileDisplay
            files={props.feedback.files.filter(f => isCMUser || !f.isCadmakersOnly)}
          />
          <br />
        </div>
      )}

      <ImageGallery images={props.feedback.images} />
    </div>
  );
};
